import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {Redirect} from 'react-router-dom';
import Slider, {Range} from 'rc-slider';
import {Link} from 'react-router-dom';
import Ripples from 'react-ripples'
import 'rc-slider/assets/index.css';
import cam from './cam';

let cupHeight = 199 - 12;
//cupHeight = (+(getComputedStyle(document.getElementById("cup-graph")).height).match(/\d+/)[0]);
if (document.body.clientWidth > 576) {
    cupHeight = 290 - 12;
}

function stopStreamedVideo(videoElem) {
    const video = document.getElementById("video");
    const canvas = document.getElementById("canvas");
    const stream = document.getElementById("video").srcObject;
    if (stream) {
        const tracks = stream.getTracks();
        video.pause();
        tracks.forEach(function (track) {
            track.stop();
        });
    }
    videoElem.srcObject = null;
    document.getElementById("loadingMessage").hidden = false;
    document.getElementById("canvas").style = "visibility: hidden";
    document.getElementById("canvas").hidden = true;
    document.getElementById("video").hidden = true;
    document.getElementById("output").style = "visibility: hidden";
    document.getElementById("cancel-btn").style = "visibility: hidden";
    document.getElementById("main-text").hidden = false;
    document.getElementById("loadingMessage").style = "visibility: hidden";
    document.getElementById("outputMessage").innerText = 'Отсканируйте QR-code кофемашины';
    document.getElementById("ButtonGo").hidden = true;
    canvas.style.height = 0;
}

function Ocli() {
    document.getElementById("ButtonGo").hidden = true;
    document.getElementById("_preloader").style.display = 'block';
    setTimeout(function () {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "https://monitor.rusholts.ru/rhcoffee/start_drink.php?qrcode=" + document.getElementById("ButtonGo").qrcode + "&token=" + global.config.token, false);
        xhr.send();
        if (global.config.lotteryPath !== '') {
            document.getElementById("_preloader").style.display = 'none';
            const video = document.getElementById("video");
            const canvas = document.getElementById("canvas");
            const stream = document.getElementById("video").srcObject;
            if (stream) {
                const tracks = stream.getTracks();
                video.pause();
                tracks.forEach(function (track) {
                    track.stop();
                });
            }
            document.getElementById("baraban-TVX").hidden = false;
            document.getElementById("loadingMessage").hidden = true;
            document.getElementById("item-title").hidden = true;
            document.getElementById("canvas").style = "visibility: hidden";
            document.getElementById("canvas").hidden = true;
            document.getElementById("video").hidden = true;
            document.getElementById("output").style = "visibility: hidden";
            document.getElementById("cancel-btn").style = "visibility: hidden";
            document.getElementById("main-text").hidden = true;
            document.getElementById("loadingMessage").style = "visibility: hidden";
            document.getElementById("outputMessage").innerText = 'Отсканируйте QR-code кофемашины';
            document.getElementById("ButtonGo").hidden = true;
            TVx();
        } else {
            TVxClose();
        }
    }, 500);
}

function TVx() {
    document.getElementById("baraban").innerHTML = '<video width="100%" autoplay="autoplay" src="http://services.rusholts.ru/Lottery_Directories/' + global.config.lotteryPath + '/slotmashine_smart.mp4"></video>';
    setTimeout(() => {
        document.getElementById("baraban").innerHTML = "";
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                document.getElementById("baraban-TVX").hidden = true;
                document.getElementById("priz-TVX").hidden = false;
            }
        };
        xhr.onload = function () {
            var responseObj = xhr.response;
            var video_TVX = responseObj.video;
            var uid_TVX = responseObj.uid;
            document.getElementById("priz").innerHTML = '<video width="90%" autoplay="autoplay" src="http://services.rusholts.ru/Lottery_Directories/' + global.config.lotteryPath + '/priz_smart/' + video_TVX + '"></video>';
            var xhrQR = new XMLHttpRequest();
            xhrQR.onload = function () {
                var responseObjQR = xhrQR.response;
                document.getElementById("baraban-TVX").hidden = true;
                document.getElementById("priz-TVX").hidden = false;
                document.getElementById("qrcode").innerHTML = responseObjQR;
                document.getElementById("TVXButtonClose").hidden = false;
            }
            xhrQR.open("GET", "https://services.rusholts.ru/qrgenerator/getqr.php?data=" + uid_TVX, true);
            xhrQR.responseType = 'html';
            xhrQR.send();
        };
        xhr.open("GET", "https://services.rusholts.ru/lottery_v2.php?function=playing&name=" + global.config.lotteryPath + "&km_serial=29612&km_type=Android&printerresponsetype=simple&token=" + global.config.lotteryToken, true);
        xhr.responseType = 'json';
        xhr.send();
        const video = document.getElementById("video");
        const canvas = document.getElementById("canvas");
        const stream = document.getElementById("video").srcObject;
        if (stream) {
            const tracks = stream.getTracks();
            video.pause();
            tracks.forEach(function (track) {
                track.stop();
            });
        }
        canvas.style.height = 0;
    }, 10000);
}

function TVxClose() {
    window.location.assign('../');
}

function GoCam(rcpnbr, coffee, water, foam, milk, powder) {
    cam({'rcpnbr': {rcpnbr}, 'coffee': {coffee}, 'water': {water}, 'foam': {foam}, 'milk': {milk}, 'powder': {powder}});
}

function prepareCam(rcpnbr, coffee, water, foam, milk, powder) {
    if (false === global.qr) {
        GoCam(rcpnbr, coffee, water, foam, milk, powder);
    } else {
        document.getElementById("_preloader").style.display = 'block';
        setTimeout(function () {
            alert('https://monitor.rusholts.ru/rhcoffee/?token='.concat(global.config.token, '&rcpnbr=').concat(rcpnbr, '&qrcode=').concat(global.qr, '&coffee=').concat(coffee, '&water=').concat(water, '&milk=').concat(milk, '&foam=').concat(foam, '&powder=').concat(powder));
            fetch('https://monitor.rusholts.ru/rhcoffee/?token='.concat(global.config.token, '&rcpnbr=').concat(rcpnbr, '&qrcode=').concat(global.qr, '&coffee=').concat(coffee, '&water=').concat(water, '&milk=').concat(milk, '&foam=').concat(foam, '&powder=').concat(powder)).then((function (e) {
                return e.text();
            })).then((function (e) {
                document.getElementById("_preloader").style.display = 'none';
                var c = document.getElementById('outputMessage');
                alert(e);
                switch (e) {
                    case '':
                        document.getElementById('send').hidden = true;
                        document.getElementById('cup-graph').hidden = true;
                        document.getElementById('slider-wrap').hidden = true;
                        c.style = 'visibility: visible';
                        var d = document.getElementById('ButtonGo'), t = document.getElementById('video');
                        if (e) {
                            c.innerText = e.split('<br>').join("\n");
                        } else {
                            c.innerText = '\u041e\u043a! \u0420\u0435\u0446\u0435\u043f\u0442 \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d \u043d\u0430 \u043a\u043e\u0444\u0435\u043c\u0430\u0448\u0438\u043d\u0443.';
                            d.hidden = false;
                            d.qrcode = global.qr;
                            t.srcObject = null;
                        }
                        global.qr = false;
                        break;
                    default:
                        global.qr = false;
                        document.getElementById('send').hidden = false;
                        document.getElementById('cup-graph').hidden = false;
                        document.getElementById('slider-wrap').hidden = false;
                        c.style = 'visibility: hidden';
                        GoCam(rcpnbr, coffee, water, foam, milk, powder);
                }
            }));
        }, 500);
    }
}

function Item(props) {
    const [coffee, setCoffee] = useState(0);
    const [powder, setPowder] = useState(0);
    const [foam, setFoam] = useState(0);
    const [water, setWater] = useState(0);
    const [milk, setMilk] = useState(0);
    const [drinkSize, setDrinkSize] = useState(0);
    const [drinkSizeMax, setDrinkSizeMax] = useState(0);
    const [coffeeColor, setCoffeeColor] = useState(1);
    const [coffeeDefault, setCoffeeDefault] = useState(0);
    const [waterDefault, setWaterDefault] = useState(0);
    const [sliderCoffee, setSliderCoffee] = useState(0);
    const [sliderWater, setSliderWater] = useState(0);
    const [rcpnbr, setRcpnbr] = useState(0);
    if (!props.location.propsCups) {
        return <Redirect to="/"/>;
    }
    const titleName = props.location.propsCups.basename.trim();
    const arrIngradients1 = props.location.propsCups.limits.filter(ingrad => ingrad.used > 0);
    const arrIngradients = arrIngradients1.map(slide => (
        slide.ingridient === 'powder' ? {
            'ingridient': slide.ingridient,
            'used': slide.used,
            'min': slide.min * 5,
            'default': slide.default * 5,
            'max': slide.max * 5
        } : slide
    ));
    if (coffee === 0 && water === 0 && milk === 0 && foam === 0) {
        let accum = 0;
        let accumMax = 0;
        arrIngradients.forEach(function (element) {
            switch (element.ingridient) {
                case 'coffee':
                    setCoffee(element.default);
                    setCoffeeDefault(element.default);
                    break;
                case 'powder':
                    setPowder(element.default);
                    accum += element.default;
                    accumMax += element.max;
                    break;
                case 'foam':
                    setFoam(element.default);
                    accum += element.default;
                    accumMax += element.max;
                    break;
                case 'water':
                    setWater(element.default);
                    setWaterDefault(element.default);
                    accum += element.default;
                    accumMax += element.max;
                    break;
                case 'milk':
                    setMilk(element.default);
                    accum += element.default;
                    accumMax += element.max;
                    break;
                default:
                    break;
            }
            setDrinkSize(accum);
            setDrinkSizeMax(accumMax);
            setRcpnbr(props.location.propsCups.rcpnbr);
        });
    }
    const mark = arrIngradients.map((slide) => ({
            [slide.min]: slide.min,
            [slide.default]: slide.default,
            [slide.max]: slide.max
        }
    ));
    let setVal = (ingrid, e) => {
        switch (ingrid) {
            case 'coffee':
                setCoffee(e);
                setCoffeeColor(((coffeeDefault - e) / 20 + 1) + sliderWater);
                setSliderCoffee((coffeeDefault - e) / 20);
                break;
            case 'powder':
                setDrinkSize(water + e + milk + foam);
                setPowder(e);
                break;
            case 'foam':
                setDrinkSize(water + milk + e + powder);
                setFoam(e);
                break;
            case 'water':
                setDrinkSize(e + milk + foam + powder);
                if (waterDefault > 200) {
                    setCoffeeColor(((e - waterDefault) / 400 + 1) + sliderCoffee);
                    setSliderWater((e - waterDefault) / 400);
                } else {
                    setCoffeeColor(((e - waterDefault) / 100 + 1) + sliderCoffee);
                    setSliderWater((e - waterDefault) / 100);
                }
                setWater(e);
                break;
            case 'milk':
                setDrinkSize(water + e + foam + powder);
                setMilk(e);
                break;
        }
    }
    return (
        <div>
            <div id='_preloader'><img src='/img/preloader.gif'></img></div>
            <div id='item-title' className='p-3 text-white'>{titleName}, {drinkSize} ml.</div>
            <div id='main-text'>
                <div id='graph' className='d-flex text-white justify-content-center align-items-center'>
                    <div id='cup-graph' className='p-3' style={{position: 'relative'}}>
                        {
                            arrIngradients.map(item => (
                                item.ingridient == 'water' ?
                                    <div id='water' key={item.ingridient} className='ingridients' style={{
                                        height: Math.round(water * (cupHeight / drinkSizeMax)),
                                        filter: `brightness(${coffeeColor})`
                                    }}>Кофе: {water} мл.</div> :
                                    item.ingridient == 'milk' ?
                                        <div id='milk' key={item.ingridient} className='ingridients'
                                             style={{height: Math.round(milk * (cupHeight / drinkSizeMax))}}>Молоко: {milk} мл.</div> :
                                        item.ingridient == 'foam' ?
                                            <div id='foam' key={item.ingridient} className='ingridients'
                                                 style={{height: Math.round(foam * (cupHeight / drinkSizeMax))}}>Пена: {foam} мл.</div> :
                                            item.ingridient == 'powder' ?
                                                <div id='powder' key={item.ingridient} className='ingridients'
                                                     style={{height: Math.round(powder * (cupHeight / drinkSizeMax))}}>Какао: {powder} мл.</div> :
                                                <></>
                            ))
                        }
                        <div className='ingridients' style={{height: 12}}></div>
                        <img id='cup-mask' src='/img/cup_mask.svg'></img>
                    </div>
                </div>
                <div id='slider-wrap' className='p-2 justify-content-center'>
                    {arrIngradients.map((slide, index) => (
                        slide.ingridient === 'waterP' ? null :
                            <div className='slider justify-content-center' key={index}
                                 id={'slider-' + slide.ingridient}>
                                <p className='slider-name'>{slide.ingridient === 'coffee' ? 'Кофе' :
                                    slide.ingridient === 'water' ? 'Вода' :
                                        slide.ingridient === 'milk' ? 'Молоко' :
                                            slide.ingridient === 'foam' ? 'Пена' :
                                                slide.ingridient === 'powder' ? 'Какао' :
                                                    <></>
                                }</p>
                                <Slider
                                    trackStyle={{backgroundColor: '#be7f65', height: 5}}
                                    handleStyle={{
                                        borderColor: '',
                                        backgroundColor: '#be7f65',
                                    }}
                                    min={slide.min} max={slide.max} onChange={(e) => setVal(slide.ingridient, e)}
                                    marks={mark[index]} step={1} defaultValue={slide.default}/>
                                <br/>
                            </div>
                    ))}
                </div>
                <div className='p-3'>
                    <Ripples>
                        <button id='send' onClick={
                            () => prepareCam(rcpnbr, coffee, water, foam, milk, powder)
                        }> Отправить на кофемашину
                        </button>
                    </Ripples>
                </div>
                <div className='p-0'>
                    <Link id='back' to='/'>Назад</Link>
                </div>
            </div>
            <div className="text-white justify-content-center align-items-center" id="loadingMessage">Камера на
                устройстве не обнаружена...
            </div>
            <canvas className='justify-content-center align-items-center ' id="canvas" hidden>
                <video id="video" width="30" height="40" autoPlay="autoPlay"></video>
            </canvas>
            <div className='p-3' id="output">
                <div id="outputMessage">Отсканируйте QR-code кофемашины</div>
                <div hidden><b>Data:</b> <span id="outputData"></span></div>
            </div>
            <div hidden id="ButtonGo" qrcode="" style={{
                backgroundImage: "url('../img/start.png')",
                width: 301,
                height: 102,
                position: 'relative',
                marginLeft: -150,
                left: '50%'
            }} onClick={e => Ocli()}></div>
            <div className='p-3'>
                <Ripples id="cancel-btn">
                    <button onClick={stopStreamedVideo}>Отменить</button>
                </Ripples>
                <div id="baraban-TVX" style={{border: "none", width: "auto", height: "auto"}} hidden>
                    <div id="baraban">
                        <img src='/img/baraban.gif'></img>
                    </div>
                </div>
                <div id="priz-TVX" style={{border: "none", width: "auto", height: "auto"}} hidden>
                    <div id="priz" width="90%"></div>
                    <div id="qrcode"></div>
                </div>
                <br/>
                <Ripples id="TVXButtonClose" onClick={e => TVxClose()} hidden>
                    <button id='TVx'> Закрыть</button>
                </Ripples>
            </div>
        </div>
    );
}

export default Item;
